$ = require 'jquery'
SelectMemberView = require 'app/scripts/views/member/select-member-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'

module.exports = class MemberSearchResultView extends View
  tagName: 'li'
  className: 'search-result-member'

  events:
    'mouseenter .js-select-member': 'hoverMember'
    'mouseleave .js-select-member': 'blurMember'

  render: ->
    @$el.empty()
    @appendSubview(@subview(SelectMemberView, @model, linkName: true))
    @

  blurMember: (e) ->
    elem = $(e.target).closest('.item').removeClass('selected')
    return

  hoverMember: (e) ->
    elem = $(e.target).closest('.item')
    Util.selectMenuItem($(e.target).closest('.js-list'), '.item', elem)
    return
